import { system } from 'styled-system';

const borderBottomStyle = system({
  borderBottomStyle: {
    property: 'borderBottomStyle',
  },
});

export default borderBottomStyle;
